import CityPageTemplate from "../city-template/CityPageTemplate";
import { hobbsConfig } from "./data";

export default function HobbsPage() {
  return <CityPageTemplate config={hobbsConfig} />;
}